import React from 'react';
import { Chip } from '@mui/material';
import { Text, Theme } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { 
    Add as AddIcon, 
    Remove as RemoveIcon 
} from '@mui/icons-material';
import CoverageBlock from '../CoverageBlock.js';

/**
 * 
 */
function _setGuidelineLinks(carrier) {
    let englishLink = null;
    let frenchLink = null;

    if (carrier === 'AIG') {
        englishLink = 'https://d6hvupc5g7lnm.cloudfront.net/files/AIG_and_Simply_Benefits_Emergency_OOP_OOC_Medical_Insurance.pdf';
    } else if (carrier === 'Desjardins') {
        englishLink = `https://d6hvupc5g7lnm.cloudfront.net/files/Travel_Assistance_Guidelines_Desjardins.pdf`;
        frenchLink = `https://d6hvupc5g7lnm.cloudfront.net/files/Voyage_Assistance_Desjardins.pdf`;
    } else if (carrier === '') {
        englishLink = 'https://d6hvupc5g7lnm.cloudfront.net/files/Travel_Assistance_Guidelines_LaCapitale.pdf';
    } else {
        englishLink = `https://d6hvupc5g7lnm.cloudfront.net/files/Travel_Assistance_Guidelines_${ carrier }.pdf`;
    }

    return { englishLink, frenchLink };
}

/**
 *
 * @param {*} props
 */
export default function OutOfCountry({ classes, expanded, outOfCountry, handleChange, theme, showDependentWarning, waivedEHC }) {
    const { englishLink, frenchLink } = _setGuidelineLinks(outOfCountry.carrier);

    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('outOfCountry')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('outOfCountry') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>Out Of Province or Country</Text>
                    {
                        waivedEHC &&
                            <Chip
                                size="small"
                                label="Waived"
                                color="primary"
                                variant="outlined"
                                style={{
                                    margin: "0 10px",
                                    borderRadius: 30,
                                    borderWidth: 2,
                                    borderColor: Theme.colors.lightGrey,
                                    fontFamily: Theme.fonts.type.heading,
                                    fontSize: 14,
                                    color: '#666'
                                }}
                            />
                    }
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    {
                        outOfCountry.isEligible !== 1 ?
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    You are currently ineligible for this benefit, if this is a mistake please contact your administrator.
                                </Text>
                            </div>
                            : null
                    }

                    {
                        showDependentWarning &&
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    You have waived this benefit for your dependents.
                                </Text>
                            </div>
                    }

                    <div style={classes.row}>
                        <Text small bold margin="10px 0px 0px 0px">
                            {
                                outOfCountry.outOfCountryMax > 0 ?
                                    `While out of country, you have $${ helpers.formatNumber(outOfCountry.outOfCountryMax) } available for medical coverage. ${ outOfCountry.isGraded ? `At age ${ outOfCountry.reducesAtAge } the trip duration reduces to ${ outOfCountry.periodAfterReduction } days while coverage reduces by ${ outOfCountry.reducesBy }%, provided the member is still actively working.` : '' }`
                                    :
                                    null
                            }
                        </Text>
                    </div>

                    <div style={{ ...classes.row }}>
                        <Text small bold margin="10px 0px 0px 0px">
                            Travel Assistance Guidelines:
                        </Text>
                    </div>

                    {
                        englishLink &&
                            <a href={englishLink} download="Travel Assistance Guidelines.pdf" style={{ textDecoration: 'none' }} target="_blank">
                                <Text
                                    color={theme.colors.skyBlue}
                                    small
                                    display="block"
                                >
                                    English
                                </Text>
                            </a>
                    }

                    {
                        frenchLink &&
                            <a href={frenchLink} download="Travel Assistance Guidelines.pdf" style={{ textDecoration: 'none' }} target="_blank">
                                <Text
                                    color={theme.colors.skyBlue}
                                    small
                                    display="block"
                                >
                                    French
                                </Text>
                            </a>
                    }

                    <React.Fragment>
                        <CoverageBlock
                            title="Type"
                            value="Up to"
                            type="header"
                        />
                        <CoverageBlock
                            title="Out of Country"
                            value={outOfCountry.outOfCountryMax}
                        />

                        {
                            outOfCountry.outOfCountryMedicalReferralMax > 0 ?
                                <CoverageBlock
                                    title="Out of Country Medical Referral"
                                    value={outOfCountry.outOfCountryMedicalReferralMax}
                                />
                                : null
                        }

                        {
                            outOfCountry.outOfCountryMedicalReferralReimbursement > 0 ?
                                <CoverageBlock
                                    title="Out of Country Referral Reimbursement"
                                    value={outOfCountry.outOfCountryMedicalReferralReimbursement}
                                    type="percent"
                                />
                                : null
                        }

                        <CoverageBlock
                            title="Trip Duration"
                            value={outOfCountry.period}
                            type="days"
                        />

                        {
                            outOfCountry.outOfCountryRollover && 
                                <CoverageBlock
                                    title="Coverage Rollover Period"
                                    value={outOfCountry.outOfCountryRollover}
                                    type="age"
                                />
                        }

                    </React.Fragment>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}